import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52835)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1388 41.3788H0.863084C0.387011 41.3788 0.000976562 40.9927 0.000976562 40.5166V9.48222C0.000976562 9.00615 0.387011 8.62012 0.863084 8.62012H49.1389C49.6149 8.62012 50.001 9.00615 50.001 9.48222V40.5166C50.0009 40.9928 49.6148 41.3788 49.1388 41.3788Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.9611 24.9994C12.9611 28.811 16.0502 31.9001 19.8583 31.9001C21.2775 31.9001 22.5862 31.464 23.6763 30.7248C23.8414 30.6129 24.0321 30.8287 23.8939 30.9726C22.3301 32.6015 20.14 33.6202 17.7032 33.6202C12.7564 33.6202 8.78312 29.45 9.10411 24.4322C9.38448 20.0513 13.0165 16.5337 17.4038 16.384C19.9575 16.2968 22.2606 17.3289 23.888 19.0208C24.0275 19.166 23.8372 19.385 23.6705 19.2721C22.5816 18.5346 21.2751 18.0989 19.8583 18.0989C16.0503 18.0989 12.9611 21.195 12.9611 24.9994Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.6819 23.8134L27.3307 22.0458C27.2552 21.9469 27.0972 22.0011 27.0983 22.1255L27.1181 24.3504L25.0193 25.0893C24.902 25.1306 24.9048 25.2975 25.0234 25.3349L27.1455 26.0038L27.1997 28.2281C27.2027 28.3524 27.3625 28.4013 27.4347 28.3L28.7265 26.4885L30.8587 27.1244C30.9778 27.1599 31.0737 27.0233 30.9997 26.9233L29.676 25.1348L30.9395 23.3035C31.0103 23.2011 30.9099 23.0677 30.7919 23.1072L28.6819 23.8134Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52835",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTrFlag);
export { ForwardRef as ReactComponent };
